import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterAuthForm.styl';


Vue.component('BXmakerAuthuserphoneEnterAuthForm', {
    name: 'BXmakerAuthuserphoneEnterAuthForm',
    data() {
        return {};
    },
    computed: {},
    methods: {
        onEnterPhone() {
            this.onClickConfirm();
        },
        onCompleteCaptcha() {
            this.onClickConfirm();
        },
        onClickConfirm() {
            if (this.$root.isFullCaptcha) {
                this.$root.authByPhone();
            }
        },
        onClickAuthByPass() {
            this.$root.setAuthByPassword();
        },
        onClickAuthByEmail() {
            this.$root.setAuthByEmailCode();
        },
        onChangePhone(data) {
            this.$root.setPhone(data.formattedValue);
        }
    },
    //language=Vue
    template: `
      <div class="bxmaker-authuserphone-enter-auth-form">

        <slot name="message">
          <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error"/>
        </slot>

        <slot name="phone">
          <BXmakerAuthuserphoneInputPhone v-if="$root.isEnabledPhoneMaskTypeBitrix"
                                          :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_FORM_PHONE"
                                          :value="$root.phone"
                                          @onChange="onChangePhone"
                                          @onEnter="onEnterPhone"
                                          name="PHONE"
                                          :mask="$root.phoneMaskParams"
          />
          <BXmakerAuthuserphoneInput v-else
                                     :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_FORM_PHONE"
                                     :value="$root.phone"
                                     @onInput="$root.setPhone"
                                     @onEnter="onEnterPhone"
                                     name="PHONE"
                                     :mask="$root.phoneMaskParams"
                                     type="tel"
          />
        </slot>


        <slot name="captcha">
          <BXmakerAuthuserphoneCaptcha
              :code="$root.captchaCode"
              :src="$root.captchaSrc"
              :length="$root.captchaLength"
              :loader="$root.captchaLoader"
              @onInput="$root.setCaptchaCode"
              @onComplete="onCompleteCaptcha"
              @onRefresh="$root.refreshCaptcha"
          />
        </slot>

        <slot name="request">
          <BXmakerAuthuserphoneButton
              :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_FORM_BUTTON"
              :loader="$root.startLoader"
              @onClick="onClickConfirm"
          />
        </slot>

        <div class="bxmaker-authuserphone-enter-auth-form__by" v-if="$root.isEnabledConfirmByEmailCode">
          <BXmakerAuthuserphoneLink @onClick="onClickAuthByEmail">
            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_FORM_BY_EMAIL}}
          </BXmakerAuthuserphoneLink>
        </div>

        <slot name="bypass">
          <div class="bxmaker-authuserphone-enter-auth-form__by">
            <BXmakerAuthuserphoneLink @onClick="onClickAuthByPass">
              {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_FORM_BY_PASS}}
            </BXmakerAuthuserphoneLink>
          </div>
        </slot>

      </div>
    `,
});